// This page happens on a new tab for OAuthentication, and nothing needs to be rendered.

/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import useOAuthFlow from './useOAuthFlow';

import { observer } from 'mobx-react';
import Grid from '@mui/material/Grid';

import ContentContainer from '../../components/contentContainer';

import { useStyles } from './styles';

import useTranslator from '../../../commons/translations';
import TranslationIds from '../../../commons/translationIds';
import EcalLogo from '../../../commons/images/EcalLogo';

function OauthTalking (props) {
    useOAuthFlow();
    const classes = useStyles();
    
    const {
        translate,
    } = useTranslator();

    return (
        <React.Fragment>
            <ContentContainer>
                <Grid>
                    <EcalLogo className={classes.frame} />
                </Grid>
                <Grid className={classes.text}>
                    {translate(TranslationIds.COMPONENT_LOADING)}
                </Grid>
            </ContentContainer>           
        </React.Fragment>
    );
}

export default observer(OauthTalking);
